import React from "react";
import useThemeColor from "../../../hooks/useThemeColor";
import "./ServeIQLoader.css";

const ROBOT_IMAGE_SRC = "/assets/img/image.png";

/**
 * Branded animated loader using the ServeIQ robot mascot.
 * @param {number} size - Width/height of the loader in pixels
 * @param {string} className - Optional extra class names
 */
const ServeIQLoader = ({ size = 72, className = "" }) => {
  const themeColor = useThemeColor();
  const glowSize = Math.round(size * 1.35);

  return (
    <div
      className={`serveiq-loader ${className}`.trim()}
      style={{
        width: size,
        height: size,
        "--serveiq-loader-accent": themeColor,
      }}
      role="img"
      aria-label="Loading"
    >
      <span
        className="serveiq-loader__glow"
        style={{ width: glowSize, height: glowSize }}
        aria-hidden="true"
      />
      <img
        src={ROBOT_IMAGE_SRC}
        alt=""
        className="serveiq-loader__robot"
        width={size}
        height={size}
        draggable={false}
      />
    </div>
  );
};

export default ServeIQLoader;